import { ToastOptions } from 'react-toastify';

export const KEY_TOKEN: string = '687b1008674f4eeea647eb588f7f6065';
export const KEY_TOKEN_CLIENT: string =
  '$2a$12$6n2FFvWFyVKtNzpptiCUWOdsv9yB0V0n1ehR6nuJ/LpC0ew95vyKq';
export const KEY_PATHS: string = 'paths';
export const KEY_PATHS_CLIENT: string = 'paths_client';
export const LOCALE: string = 'LOCALE';
export const TOAST_COLOR_THEME: string = 'colored';
export const COMPANY_ID: string = 'company_id';
export const COMPANY_NAME: string = 'company_name';
export const INITIAL_PATH: string = import.meta.env.VITE_INITIAL_PATH || '/rateweb/ratemain';

export const CONFIG_MAIN_TOAST: ToastOptions = {
  theme: TOAST_COLOR_THEME,
  position: 'top-left',
  autoClose: 1000,
};

export const DEBOUNCE_START_DELAY = 350;

export const MAX_ZOOM = 20;
export const MIN_ZOOM = 5;
export const MAP_CENTER = { lat: 39.78373, lng: -98.585968 };

export const PER_PAGES = [20, 30, 40, 50, 100, 200, 300, 500];

export { SwalConfig } from './Swal';
export * as Views from './views';

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'go2:api-clients:token',
  USER: 'go2:api-clients:user',
};
